export default "__VITE_ASSET__DY056KIZ__"